import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ICom0103PState, IAllUserItemState, IRecipientItemState } from '../../models/com/com0103p_model';
  
const initialState: ICom0103PState = {
    allUserList: [],            // 전체사용자리스트
    recipientList: [],          // 수신자리스트
    selectedUsrRowKeys : [],    // 선택사용자로우
    selectedRecRowKeys : [],    // 선택수신자로우
    clearCheckBox : false,
}

export const com0103p_Slice = createSlice({
    name: "com0103p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , allUserList: state.allUserList});
        },
        clearCheckBox: (state, action:PayloadAction<boolean>) => {
            state.clearCheckBox = action.payload;
        },
        setAllUserList: (state, action:PayloadAction<IAllUserItemState[]>) => {
            state.allUserList = action.payload;
        },
        setRecipientList: (state, action:PayloadAction<IRecipientItemState[]>) => {
            state.recipientList = action.payload;
        },
        setSelectedUsrRowKeys: (state, action:PayloadAction<string[]>) => {
            state.selectedUsrRowKeys = action.payload;
        },
        setSelectedRecRowKeys: (state, action:PayloadAction<string[]>) => {
            state.selectedRecRowKeys = action.payload;
        },
        addRecipientList: (state, action:PayloadAction<IRecipientItemState>) => {
            const arr : IRecipientItemState[] = [...state.recipientList];

            const ttt = arr.filter((item:IRecipientItemState) => {
                return item.empNo === action.payload.empNo
            });

            if (ttt.length < 1) {
                arr.push(action.payload);
                
                return {
                    ...state,
                    recipientList: arr
                }
            } else {
                return {
                    ...state,
                }
            }
        },
        removeRecipientList: (state) => {
            const arr : IRecipientItemState[] = [...state.recipientList];
            
            const ttt = arr.filter((item:IRecipientItemState) => {
                return !state.selectedRecRowKeys.includes(item.empNo);
            });

            return {
                ...state,
                recipientList: ttt
            }
        },
    },
});

export default com0103p_Slice.reducer;
export const Com0103pAction  = com0103p_Slice.actions;
export const Com0103pReducer = com0103p_Slice.reducer;